import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useRef } from "react";
import { FiUpload } from "react-icons/fi";

const ExportDataXlsx = ({ exportDataXlsx, fileNames, startDate, endDate }) => {
  const dRef = useRef();

  const handleExportXLSX = (e) => {
    e.preventDefault();
    // console.log(exportDataXlsx,fileNames);

    if (!exportDataXlsx || exportDataXlsx.length === 0) return;

    let worksheet;

    // Check if data is AoA or JSON
    if (Array.isArray(exportDataXlsx) && Array.isArray(exportDataXlsx[0])) {
      // Already an AoA format
      worksheet = XLSX.utils.aoa_to_sheet(exportDataXlsx);
    } else if (
      Array.isArray(exportDataXlsx) &&
      typeof exportDataXlsx[0] === "object"
    ) {
      // JSON array (convert to AoA)
      const headers = Object.keys(exportDataXlsx[0]);
      const rows = exportDataXlsx.map((obj) => headers.map((h) => obj[h]));
       // Create worksheet from data
    if (Array.isArray(exportDataXlsx) && Array.isArray(exportDataXlsx[0])) {
      worksheet = XLSX.utils.aoa_to_sheet(exportDataXlsx);
    } else if (
      Array.isArray(exportDataXlsx) &&
      typeof exportDataXlsx[0] === "object"
    ) {
      const headers = Object.keys(exportDataXlsx[0]);
      const rows = exportDataXlsx.map((obj) => headers.map((h) => obj[h]));
      worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
    } else {
      console.warn("Unsupported export data format");
      return;
    }

    // Apply wrapText for all cells containing newlines
    Object.keys(worksheet).forEach((cellAddr) => {
      if (cellAddr[0] === "!") return; // skip metadata keys
      const cell = worksheet[cellAddr];
      if (typeof cell.v === "string" && cell.v.includes("\n")) {
        if (!cell.s) cell.s = {};
        cell.s.alignment = { wrapText: true, vertical: "top" };
      }
    });
    } else {
      console.warn("Unsupported export data format");
      return;
    }

    // Header bold
    const range = XLSX.utils.decode_range(worksheet["!ref"]);
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
      if (!worksheet[cellAddress]) continue;
      if (!worksheet[cellAddress].s) worksheet[cellAddress].s = {};
      worksheet[cellAddress].s.font = { bold: true };
    }

    // Create a new workbook and append the sheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Convert to binary Excel file
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
      cellStyles: true,
    });

    // Saving a file
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const formatFileDate = (date) => {
      if (!date) return "";
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    };

    const start = formatFileDate(startDate);
    const end = formatFileDate(endDate);

    const finalFileName =
      start && end
        ? `${fileNames} (${start} - ${end}).xlsx`
        : `${fileNames}.xlsx`;

    saveAs(blob, finalFileName);
  };

  return (
    <div className="flex flex-grow-0">
      <div ref={dRef} className="flex-1">
        <button
          onClick={handleExportXLSX}
          className="border flex justify-center items-center border-gray-300 hover:border-green-400 hover:text-green-400 dark:text-gray-300 cursor-pointer h-10 w-20 rounded-md focus:outline-none min-h-[50px]"
        >
          <FiUpload className="mr-2" />
          <span className="text-xs">Export</span>
        </button>
      </div>
    </div>
  );
};

export default ExportDataXlsx;
